import {Model} from 'vue-mc';
import Vue from "vue";
import http from "../httpMiddleware/http";

Model.prototype.$http = http;
export default class policyDocumentsModel extends Model {

	defaults() {
		return {
			inBuiltApi: Vue.prototype.$interpretersApiUrl,
			methodTypes: 'view',
			file_name: '',
			data: {
				policy_document_id: 0
			},
			dbData: {
				unreadCount: 0
			}
		}
	}

	options() {
		return {
			methods: {
				view: 'GET',
				PDCount: 'GET',
				PDReadByInterpreter: 'POST'
			}
		}
	}

	routes() {
		return {
			view: 'interpreter/policyDocument/view?token=',
			PDCount: 'interpreter/policyDocument/readCount',
			PDReadByInterpreter: 'interpreter/policyDocument/read'
		}
	}

	requestRoute() {
		let headers = {
			Bearer: localStorage.getItem('jwt')
		};
		let method = this.getOption('methods.' + this.methodTypes);
		let route = this.inBuiltApi + this.getRoute(this.methodTypes);
		let params = this.getRouteParameters();
		let url = this.getURL(route, params);
		let data = this.data;

		// console.log(headers, method, url, data);

		return this.getRequest({headers, method, url, data}).send();
	}

	getPDReadCount() {
		this.methodTypes = 'PDCount';
		return this.requestRoute();
	}

	saveAsRead() {
		this.methodTypes = 'PDReadByInterpreter';
		return this.requestRoute();
	}
}
